module.exports = __webpack_public_path__ + "bb0769ce5a880d7354fb9a9407c624b2.jpg";